import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//router
import { createBrowserRouter, RouterProvider } from "react-router-dom";
//store
import { Provider } from "react-redux";
//reducer
import { store } from "./store";

// import Index from "./views/index"; // DELETED - Hope UI demo page
import { IndexRouters } from "./router";
import { SimpleRouter } from "./router/simple-router";
import { DefaultRouter } from "./router/default-router";
import { UsersRouter } from "./router/users-router";
import {StudentRouter} from "./router/student-router";
import {
  GlobalStateProvider,
  useGlobalState,
} from "../src/services/hostelConst";
import { Global } from "@emotion/react";
const router = createBrowserRouter(
  [
    ...UsersRouter,
    ...DefaultRouter,
    // ...IndexRouters,
    ...SimpleRouter,
    ...StudentRouter,
    // {
    //   path: "/magic-route",
    //   element: <Index />,
    // },
  ],
  { basename: process.env.PUBLIC_URL }
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <GlobalStateProvider>
      <App>
        <RouterProvider router={router}></RouterProvider>
      </App>
    </GlobalStateProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log("hello"));
